
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gOsZ9rwypAuYlOLCMayFZF_45bdqskC3ZfOgwBrhcQ9J_0Meta } from "/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexCB_45QemZXC8jUX38darmOtL0m4EuPHRhdFnARH9dZXKQMeta } from "/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchnUBn_7IRrQ9zyDhztaf9qms8ce1aQZmXiGIQBADHPcgMeta } from "/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexHW17v8Vt_45SipKJ2Y3c4LTYtXLAkcTYF0ALHDvS_450CO8Meta } from "/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93yIVPun51oWvcQvCkj93f9lMg7RFiP6gt3e6zKTvD6sYMeta } from "/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexgLAOYx9UFJA9zObl_xZW3bTuOCaHWDJwtFLcynY_st8Meta } from "/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93v0aPxtHqW7oCrBjYXIsL0asOAgYaZM3qxrgdCuImYdwMeta } from "/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexQGPA3C8DTNYTnnCH80tPNKeLZNY69ytJ6CUWd0Vv5mUMeta } from "/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93c8_PdLcwTeUoG0qRa5c0Wqu7kdJuaV4_45kY_45GU88YeCoMeta } from "/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexJEWbHTT2G_ztiOrZwiLqCm72Rmi1SDbU0GE1eTPqsy4Meta } from "/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexC5FR28DwuD54ZASg4N3Q_45CsjZ_45W46htE1zeG0GDux7wMeta } from "/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexgLAOYx9UFJA9zObl_xZW3bTuOCaHWDJwtFLcynY_st8Meta || {},
    component: () => import("/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexQGPA3C8DTNYTnnCH80tPNKeLZNY69ytJ6CUWd0Vv5mUMeta || {},
    component: () => import("/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexJEWbHTT2G_ztiOrZwiLqCm72Rmi1SDbU0GE1eTPqsy4Meta || {},
    component: () => import("/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexC5FR28DwuD54ZASg4N3Q_45CsjZ_45W46htE1zeG0GDux7wMeta || {},
    component: () => import("/codebuild/output/src2205565418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]